import React, { forwardRef, useCallback, useEffect } from 'react';
import { get, has, set } from 'lodash';

export const FileInput = forwardRef(({ value, onChange, allowedFileTypes, ...rest }: any, ref: any) => {
  useEffect(() => {
    if (has(ref, 'current')) {
      set(ref, 'current.value', value || '');
    }
  }, [value, ref]);

  const onChangeFile = useCallback(
    e => {
      if (e.target.value) {
        onChange && onChange(get(ref, 'current.files'));
      }
    },
    [ref, onChange]
  );

  return <input ref={ref} {...rest} type="file" accept={allowedFileTypes} onChange={onChangeFile} />;
});
